import React, { useState, useEffect, useContext } from 'react'
import { AllStarContext } from '../../../../Context'
import { SelPosCon } from '../../styles'
import { PlayersOnTeam } from '../../../../Api'
import { DefaultPlayerItem } from './DefaultPlayerItem'
import { Img } from '../../../../Components/Image/Img'
import { formatPlayerName, sortAllStarOrderByPosition } from '../../../../Utils'
import { ALL_STAR_TEAM_RULES } from '../../../../Constants/allStar'
import { getASGTeamColor, mergePosition } from '../../../../Utils/AllStar/allStarHelper'
import { colors } from '../../../../Components/consts'

type SelectedPlayersListParams = {
  pos: string
}

export const SelectedPlayersRow: React.FC<
  React.PropsWithChildren<SelectedPlayersListParams>
> = ({ pos }) => {
  const { selectedTeamOnePlayers, selectedTeamTwoPlayers, playerType, removePlayer } =
    useContext(AllStarContext)!
  const [availSpots, setAvailSpots] = useState<number | null>()
  const [players, setPlayers] = useState<PlayersOnTeam[]>([])
  const textColor =
    getASGTeamColor(playerType) === colors.darkBlue ? colors.white : colors.black

  useEffect(() => {
    setupPlayersRow()
  }, [])

  useEffect(() => {
    setupPlayersRow()
  }, [selectedTeamOnePlayers, selectedTeamTwoPlayers, playerType])

  const setupPlayersRow = () => {
    let spots = getTotalSpots()
    let ps = playerType === 'east' ? selectedTeamOnePlayers : selectedTeamTwoPlayers
    let playersByPos = ps.filter((p) => mergePosition(p.currentTeam?.position) === mergePosition(pos))
    const avail = spots - playersByPos.length
    setAvailSpots(avail)
    const sorted = sortAllStarOrderByPosition(playersByPos)
    setPlayers(sorted)
  }

  const getTotalSpots = () => {
    return ALL_STAR_TEAM_RULES[pos]
  }

  return (
    <SelPosCon color={textColor}>
      <div className="posNameCol">
        <p className="posNum">{`${players.length}/${getTotalSpots()}`}</p>
      </div>
      <div className="selectedCon">
        {players.map((player) => (
          <div className="selectedItem" key={player.officialId}>
            <div className="profileCon">
              <Img
                className="profile"
                src={player.profileUrl}
                alt={`${player.lastName} Profile Picture`}
              />
              <div
                className="removeCon"
                onClick={() => {
                  removePlayer(player)
                }}
              >
                <div className="sign">-</div>
              </div>
            </div>
            <div className="name">
              {formatPlayerName(player.firstName, player.lastName)}
            </div>
          </div>
        ))}
        {availSpots && availSpots > 0
          ? Array.from({ length: availSpots }, (_, idx) => (
              <DefaultPlayerItem key={idx} position={pos} />
            ))
          : null}
      </div>
    </SelPosCon>
  )
}
